import { Inject, Injectable } from '@angular/core';

/**
 * TODO: We should look to refactor such that this approach is not required, if it's being consumed (configs can be pulled in several ways)
 */
export const ECP_WORKFLOW_ENVIRONMENT_TOKEN = 'ecp_workflow_environment_token';
export interface ECPWorkflowEnvironment {
  aiInstrumentationKey: string;
  production: boolean;
  environmentFile?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  adminPortalApi: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  consumerPortalApi: any[];
  checkForAppIdAttempts: number;
  paymentCalculatorURL: string;
}

// TODO 208381: Let's look at how we're initializing configs. See 208381.
@Injectable({ providedIn: 'root' })
export class EcpWorkflowEnvironmentService {
  constructor(@Inject(ECP_WORKFLOW_ENVIRONMENT_TOKEN) public readonly ecpWorkflowEnvironment: ECPWorkflowEnvironment) {}
}
